export default "__VITE_PUBLIC_ASSET__d8d72758__"